import React, { useEffect, useState } from "react";
import styles from "./LoadingOverlay.module.css";

interface LoadingOverlayProps {
  message: string;
  startTime?: number;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  message,
  startTime = Date.now(),
}) => {
  const [elapsedTime, setElapsedTime] = useState<number>(0);

  // Update elapsed time every 100ms for debugging
  useEffect(() => {
    const timer = setInterval(() => {
      setElapsedTime(Math.floor((Date.now() - startTime) / 100) / 10);
    }, 100);

    return () => clearInterval(timer);
  }, [startTime]);

  return (
    <div className={styles.overlay}>
      <div className={styles.content}>
        <img
          src="https://media.evefant.com/isotipo_animado_evf_azul_427fb937d9.gif"
          alt="Loading"
          className={styles.loadingGif}
        />
        <p className={styles.message}>{message}</p>
        {process.env.NODE_ENV === "development" && (
          <p className={styles.debugTime}>Loading: {elapsedTime}s</p>
        )}
      </div>
    </div>
  );
};

export default LoadingOverlay;
